import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
const navLinks = [{
  label: 'HOME',
  href: '#home'
}, {
  label: 'SLUŽBY',
  href: '#sluzby'
}, {
  label: 'KOMERČNÍ ŘEŠENÍ',
  href: '#komercni'
}, {
  label: 'REZIDENTNÍ ŘEŠENÍ',
  href: '#rezidentni'
}, {
  label: 'O NÁS',
  href: '#onas'
}, {
  label: 'KONTAKT',
  href: '#kontakt'
}];
const socialLinks = [{
  icon: FacebookIcon,
  href: '#',
  label: 'Facebook'
}, {
  icon: InstagramIcon,
  href: '#',
  label: 'Instagram'
}, {
  icon: LinkedinIcon,
  href: '#',
  label: 'LinkedIn'
}, {
  icon: YoutubeIcon,
  href: '#',
  label: 'YouTube'
}];
export function Footer() {
  return <footer className="w-full bg-[#2a2a2a] text-white" data-id="element-143">
      <div className="max-w-6xl mx-auto px-6 py-12" data-id="element-144">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start" data-id="element-145">
          {/* Logo */}
          <div data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/k5fHHKued9vuhivXuUB9Kx/LOGO_LANGARD.svg" alt="LANGARD" className="h-8 w-auto brightness-0 invert opacity-50" data-id="element-147" />
          </div>

          {/* Navigation Links */}
          <nav data-id="element-148">
            <ul className="space-y-2" data-id="element-149">
              {navLinks.map(link => <li key={link.label} data-id="element-150">
                  <a href={link.href} className="text-sm text-[#808080] hover:text-[#b0b0b0] transition-colors" data-id="element-151">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Social Links */}
          <div className="flex items-center gap-3 md:justify-end" data-id="element-152">
            {socialLinks.map(social => <a key={social.label} href={social.href} aria-label={social.label} className="w-9 h-9 rounded-full bg-[#444] flex items-center justify-center hover:bg-[#555] transition-colors" data-id="element-153">
                <social.icon className="w-4 h-4 text-[#999]" data-id="element-154" />
              </a>)}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-[#3a3a3a]" data-id="element-155">
        <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-156">
          <p className="text-right text-sm text-[#666]" data-id="element-157">
            Všechna práva vyhrazena (c) 2026
          </p>
        </div>
      </div>
    </footer>;
}